module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NAoSBG/tc-custom/9781439673553.jpg?1705026193254",
      "alt": "This image is the cover for the book Arizona's Haunted Route 66, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Arizona's Haunted Route 66, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Arizona claims one of the longest segments of the famous Route 66. Along the nearly four hundred miles of road are stops filled with legends, history, superstitions and spirits of travelers who experienced untimely accidents and murders. Meet Leorena Shipley, an aspiring actress whose career was cut short by tragedy. Discover how the Apache Death Cave became the haunted site of a mass grave. Visit the Monte Vista Hotel, one of the most haunted hotels in Arizona. Learn how the Grand Canyon Caverns were discovered and became a favorite attraction. Travel to Oatman, a ghost town with a multitude of spirits. Join author and paranormal historian Debe Branning on a haunted road trip across Arizona and discover the spooky history of the Mother Road.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debe Branning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Debe Branning has been the director of the MVD Ghostchasers since 1994, conducting investigations of haunted, historical locations throughout Arizona. She is a paranormal journalist and has been a guest lecturer at several Arizona universities and community colleges, science fiction and paranormal conferences, historical societies and libraries. She has shared her expertise on several television shows and is the author of six previous books on the paranormal and three children's books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0